module.exports = __webpack_public_path__ + "img/billing.3d949d7b.png";